import { EditedParticipation } from "../../../Partner/EditedPartner";
import { Filter } from "../../ParticipationFunctions/Filtering";
import { offsetOneRow, offsetTwoRows, StateStyledCell } from "../../Styles/ParticipationTableStyles";
import { CellWithValidator, StickyHeader } from "../../../../components/Table/TableStyles";
import { ValidatedIcon, ValidateFilter, ValidateFilterValue } from "../../../../components/Controls/ValidateControl";
import { TextFilter } from "../../../../components/Form/FormStyles";

export function CommunitySitePostalCodeHeader() {
	return (
		<StickyHeader
			style={{
				...offsetOneRow,
				width: '160px',
				minWidth: '160px',
				maxWidth: '160px'
			}}>
			Community site postal code
		</StickyHeader>
	)
}

export function CommunitySitePostalCodeFilter({ filter, updateFilter }: { filter: Filter, updateFilter: (filter: Filter) => void }) {
	return (
		<StickyHeader style={{ ...offsetTwoRows }}>
			<CellWithValidator>
				<ValidateFilter
					value={
						filter?.CommunitySitePostalCodeValidated ??
						ValidateFilterValue.Unset
					}
					onChange={(e) =>
						updateFilter({
							...filter,
							CommunitySitePostalCodeValidated: e.value
						})
					}
				/>
				<TextFilter
					value={filter?.CommunitySitePostalCode ?? ''}
					onChange={(e) =>
						updateFilter({
							...filter,
							CommunitySitePostalCode: e.target.value
						})
					}
				/>
			</CellWithValidator>
		</StickyHeader>
	)
}

export function CommunitySitePostalCodeContent({ ppn }: { ppn: EditedParticipation }) {
	return (
		<StateStyledCell
			editStatus={ppn.EditStatus}
			modified={ppn.PlantingProjectId.modified}>
			<CellWithValidator>
				<span>
					{ppn.PlantingProject.CommunitySitePostalCodeValidated && (
						<ValidatedIcon />
					)}
				</span>
				<span>{ppn.PlantingProject.CommunitySitePostalCode}</span>
			</CellWithValidator>
		</StateStyledCell>
	)
}